import React from 'react';
import Pagination from 'react-bootstrap/Pagination';

export default function CustomPagination({ totalPage, currentPage, setCurrentPage}) {
    return (
        <Pagination>
            <Pagination.First onClick={() => setCurrentPage(0)} />
            {+currentPage > 0 && <Pagination.Prev onClick={() => setCurrentPage(+currentPage - 1)} />}
            {+currentPage > 10 && <Pagination.Ellipsis onClick={() => setCurrentPage(+currentPage - 10)} />}
            {/* {+currentPage > 1 && <Pagination.Item onClick={() => setCurrentPage(+currentPage - 2)}>{+currentPage - 1}</Pagination.Item>} */}
            {/* {+currentPage > 0 && <Pagination.Item onClick={() => setCurrentPage(+currentPage - 1)}>{+currentPage}</Pagination.Item>} */}
            <Pagination.Item active activeLabel={false} onClick={() => setCurrentPage(+currentPage)}>{+currentPage + 1}</Pagination.Item>
            {/* {+currentPage < totalPage - 2 && <Pagination.Item onClick={() => setCurrentPage(+currentPage + 1)}>{+currentPage + 2}</Pagination.Item>} */}
            {/* {+currentPage < totalPage - 3 && <Pagination.Item onClick={() => setCurrentPage(+currentPage + 2)}>{+currentPage + 3}</Pagination.Item>} */}
            {+currentPage < totalPage - 10 && <Pagination.Ellipsis onClick={() => setCurrentPage(+currentPage + 10)} />}
            {+currentPage < totalPage - 1 && <Pagination.Next onClick={() => setCurrentPage(+currentPage + 1)} />}
            <Pagination.Last onClick={() => setCurrentPage(totalPage - 1)} />
        </Pagination>
    )
}
 